import Base from './base'

export default class Tags extends Base {
  team() {
    return this.api.get(`teams/tags.json`)
  }

  allForUserId(userId) {
    return this.api.post(`people_v2/${userId}/tags.json`)
  }

  createForUserId(userId, tags) {
    return this.api.post(`people_v2/${userId}/add_tags.json`, {
      tags: tags,
    })
  }

  removeForUserId(userId, tags) {
    return this.api.post(`people_v2/${userId}/remove_tags.json`, {
      tags: [tags],
    })
  }
}
